import { Dayjs } from "dayjs"
import { MandrillEmailParser } from "@/models/mandrillEmail/mandrillEmail.parser"
import { MandrillEmail } from "@/models/mandrillEmail/mandrillEmail"
import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { MandrillSearchResult } from "@/api/backofficeRest/generated/model"

export interface IMandrillService {
  getMandrillEmailsList(
    query: string,
    fromDate: Dayjs,
    toDate: Dayjs,
  ): QueryResult<MandrillEmail[]>
}

class MandrillServiceClass implements IMandrillService {
  getMandrillEmailsList(
    query: string,
    fromDate: Dayjs,
    toDate: Dayjs,
  ): QueryResult<MandrillEmail[]> {
    const from = fromDate.format("YYYY-MM-DD")
    const to = toDate.format("YYYY-MM-DD")

    return useQuery({
      ...BackofficeRestQueries.communication.mandrillSearch(query, from, to),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData: MandrillSearchResult[]) =>
        (rawData ?? []).map(MandrillEmailParser.toDomain),
      showSnackbarError: true,
      meta: {
        errorMessage: "Could not search email delivery status",
      },
    })
  }
}

export const MandrillService = new MandrillServiceClass()
